import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

const isDev = process.env.NODE_ENV !== "production";

export const signUp = async (userData) => {
  return apiRequest(`${API_ENDPOINTS.CANDIDATES}/signup`, {
    method: "POST",
    body: userData,
    fallbackMessage: "Erro ao cadastrar usuário",
    errorCode: "SIGNUP_FAILED",
  });
};

export const login = async (credentials) => {
  return apiRequest(API_ENDPOINTS.LOGIN, {
    method: "POST",
    body: credentials,
    fallbackMessage: "Erro ao fazer login",
    errorCode: "LOGIN_FAILED",
  });
};

export const forgotPassword = async (email) => {
  const result = await apiRequest(API_ENDPOINTS.FORGOT_PASSWORD, {
    method: "POST",
    body: { email },
    fallbackMessage: "Nao foi possivel enviar o email de recuperacao.",
    errorCode: "FORGOT_PASSWORD_FAILED",
  });

  if (isDev) {
    console.info("[auth] Solicitação de reset de password enviada", { email });
  }

  return result;
};

export const validateResetToken = async (token) => {
  if (!token) {
    throw new Error("Token de reset nao informado.");
  }

  const tokenQuery = encodeURIComponent(token);

  let response = await apiRequest(
    `${API_ENDPOINTS.VALIDATE_RESET_TOKEN}?token=${tokenQuery}`,
    {
      method: "GET",
      responseType: "raw",
      fallbackMessage: "Token invalido ou expirado.",
      errorCode: "RESET_TOKEN_VALIDATE_FAILED",
    }
  ).catch((error) => error);

  // Fallback para APIs que implementam validação via POST.
  if (response?.status === 404 || response?.status === 405) {
    return apiRequest(API_ENDPOINTS.VALIDATE_RESET_TOKEN, {
      method: "POST",
      body: { token },
      fallbackMessage: "Token invalido ou expirado.",
      errorCode: "RESET_TOKEN_VALIDATE_FAILED",
    });
  }

  if (response instanceof Error) {
    throw response;
  }

  return response.json().catch(() => ({ valid: true }));
};

export const resetPassword = async ({ token, password, confirmPassword }) => {
  const result = await apiRequest(API_ENDPOINTS.RESET_PASSWORD, {
    method: "POST",
    body: {
      token,
      password,
      confirmPassword,
    },
    fallbackMessage: "Nao foi possivel redefinir a password.",
    errorCode: "RESET_PASSWORD_FAILED",
  });

  if (isDev) {
    console.info("[auth] Password redefinida com sucesso");
  }

  return result;
};

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;

  // Verificar expiração se necessário
  const expiration = localStorage.getItem("tokenExpiration");
  if (expiration && Date.now() > Number.parseInt(expiration, 10)) {
    logout();
    return false;
  }

  return true;
};

export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("rememberMe");
  window.dispatchEvent(new Event("auth:logout"));
};
